import { gql } from "@apollo/client";

export const RATE_MUTATION = gql`
  mutation rate($input: RateInput!) {
    rate(input: $input) {
      type
      resourceType
      message
      sentiment
      rating
      resourceId
      category
      extras
    }
  }
`;
